<template>
	<div>
		<el-row class="contents" style="padding-left:5px">
			<!-- 查询条件 -->
			<el-col :span="24" class="handleQuery">
				<el-form :inline="false" :model="addOrUpdateForm" ref="addOrUpdateForm" :rules="rules" class="form" size="small" label-width="90px">
					<el-form-item label="运营记录:" prop="content">
						<el-input type="textarea" :autosize="{ minRows: 3}" v-model="addOrUpdateForm.content"></el-input>
					</el-form-item>
					<el-form-item label="上传图片:">
						<el-upload :file-list="imageList" action="/api/system/file/upload" list-type="picture-card" :on-success="handleUploadSuccess" :before-upload="beforeUpload"
							:headers="headers" :auto-upload="true">
							<i slot="default" class="el-icon-plus"></i>
							<div slot="file" slot-scope="{file}">
								<el-image style="width: 80px; height: 80px" :src="file.url" fit="fit"></el-image>
								<span class="el-upload-list__item-actions">
									<span class="el-upload-list__item-preview" @click="handlePictureCardPreview(file)">
										<i class="el-icon-zoom-in"></i>
									</span>
									<span class="el-upload-list__item-delete" @click="handleRemove(file)">
										<i class="el-icon-delete"></i>
									</span>
								</span>
							</div>
						</el-upload>
					</el-form-item>
					<el-form-item>
						<el-button type="primary" :disabled="uploading" size="small" @click="handleUpdate">提交</el-button>
					</el-form-item>
				</el-form>
			</el-col>

			<div class="head">
				<span>运营历史记录</span>
			</div>
			<!-- 列表 -->
			<el-col :span="24">
				<el-table v-loading="loading" :data="datas" stripe border style="width: 100%" ref="multipleTable" tooltip-effect="dark" @selection-change="handleSelectionChange">
					<el-table-column prop="id" label="序号" width="60">
						<template slot-scope="scope">
							{{scope.$index+1}}
						</template>
					</el-table-column>
					<el-table-column prop="content" label="运营记录"></el-table-column>
					<el-table-column prop="content" label="图片">
						<template slot-scope="scope">
							<el-image style="width: 50px; height: 50px;margin-right:5px" :src="image" fit="fit" :key="index" v-for="(image,index) in scope.row.imageList" :preview-src-list="scope.row.imageList"></el-image>
						</template>
					</el-table-column>
					<el-table-column prop="creatorName" label="提交人"></el-table-column>
					<el-table-column prop="createTime" label="提交时间"></el-table-column>
				</el-table>

				<!-- 分页 -->
				<el-pagination background layout="total, sizes, prev, pager, next, jumper" :page-sizes="[10, 20, 30, 50, 100]" :current-page="queryParams.currentPage"
					:page-size="queryParams.pageSize" :total="totalNum" @size-change="pageSizeChange" @current-change="pageCurrentChange"></el-pagination>
			</el-col>
		</el-row>

		<el-dialog :visible.sync="dialogPreviewVisible">
		  <img width="100%" :src="dialogImageUrl" alt="">
		</el-dialog>
		
	</div>
</template>

<script>
	import BaseSearch from '@/components/layout/base/base-search-front';

	export default {
		extends: BaseSearch,
		props: ['device'],
		data() {
			return {
				url: 'mngr/operation/log',
				name: '运营记录',
				rules: {
					content: [{
							required: true,
							message: '请输入运营记录',
							trigger: 'blur'
						},
						{
							max: 500,
							message: '运营记录最长支持500字',
							trigger: 'blur'
						}
					],
				},
				imageList: [],
				dialogImageUrl: "",
				dialogPreviewVisible: false,
				addOrUpdateForm: {
					content: "",
					imageList: []
				},
				uploading:false
			};
		},
		filters: {},
		methods: {
			beforeUpdate() {
				this.addOrUpdateForm.deviceId=this.device.id
			},
			handleUploadSuccess(res, file) {
				this.imageList.push(file);
				this.addOrUpdateForm.imageList.push(res.data);
				this.uploading=false;
			},
			handlePictureCardPreview(file) {
				this.dialogImageUrl = file.url;
				this.dialogPreviewVisible = true;
			},
			handleRemove(file) {
				var index = this.imageList.findIndex(item => item.uid === file.uid)
				this.imageList.splice(index, 1);
				this.addOrUpdateForm.imageList.splice(index, 1);
			},
			afterUpdate(){
				this.addOrUpdateForm.content=""
				this.addOrUpdateForm.imageList=[]
				this.imageList=[]
			},
			beforeUpload(file) {
			  // 支持的文件类型
			  const isImage = ['image/jpeg', 'image/png', 'image/jpg'].includes(file.type);
			  const isLt2M = file.size / 1024 / 1024 < 2;
			
			  if (!isImage) {
			    this.$message.error('上传图片只能是 JPG、PNG 格式!');
			  }
			  if (!isLt2M) {
			    this.$message.error('上传图片大小不能超过 2MB!');
			  }
			  if(isImage && isLt2M){
				  this.uploading=true;
			  }
			  return isImage && isLt2M;
			}
		},
		mounted: function() {
			this.queryParams.deviceId = this.device.id;
			this.addOrUpdateForm.deviceId=this.device.id;
		}
	};
</script>

<style scoped>
	.el-dialog {
		width: 35% !important;
	}
	
	/deep/ .el-upload-list--picture-card .el-upload-list__item {
		width: 80px;
		height: 80px;
	}
	
	/deep/ .el-upload--picture-card {
		width: 80px;
		height: 80px;
		line-height: 90px;
	}
	
</style>


// WEBPACK FOOTER //
// src/view/front/device/operationLog.vue